import figures from './rpgFigures.json';

export { figures };
export const mentorFigures = {
  'Medicina general': 'general', 'Medicina Interna': 'internista', 'Pediatría': 'pediatra',
  'Ginecología y Obstetricia': 'ginecologa', 'Cirugía': 'cirujano', 'Urgencias': 'urgenciologa',
  'Cardiología': 'cardiologo', 'Nefrología': 'nefrologa', 'Neurología': 'neurologo',
  'Neumología': 'neumologa', 'Endocrinología': 'endocrinologa', 'Dermatología': 'dermatologo',
  'Traumatología y Ortopedia': 'traumatologa', 'Psiquiatría': 'psiquiatra',
  'Analgesia y Anestesia': 'anestesiologo', 'Otros': 'general',
};
const fold = (s) => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
export const clinicalCast = (state) => {
  const explicitMentor = state.mentor && state.mentor !== state.module ? state.mentor : null;
  const specialty = explicitMentor || (mentorFigures[state.submodule] ? state.submodule : state.module) || state.specialty;
  const mentor = mentorFigures[specialty] || 'general';
  const context = fold(`${state.title} ${state.subtitulo_caso}`);
  let patient = 'adulto';
  if (/embaraz|gestant|obstetri|preeclamps|eclamps|binomio/.test(context) || state.module === 'Ginecología y Obstetricia') patient = 'embarazada';
  if (state.module === 'Pediatría' || /pediatr|neonato|lactante|escolar/.test(context)) {
    patient = /recien nacido|neonat|binomio/.test(context) ? 'recien-nacido' : /lactante/.test(context) ? 'lactante' : /adolescente/.test(context) ? 'adolescente' : /nina|femenin/.test(context) ? 'nina' : 'nino';
  } else if (/geriatr|adulto mayor|anciano/.test(context)) patient = 'adulto-mayor';
  else if (/adolescente/.test(context)) patient = 'adolescente';
  const equipment = mentor === 'ginecologa' ? 'ecografo' : mentor === 'neumologa' || mentor === 'anestesiologo' ? 'ventilador' : mentor === 'urgenciologa' || mentor === 'cardiologo' ? 'desfibrilador' : 'monitor';
  return { mentor, patient, equipment };
};